<template>
    <div class="d-flex bg-white border-top px-5 py-2">
        <button :id="openAppBtnId" @click="openApp" type="button" class="btn btn-danger btn-block rounded-lg py-2 font-weight-bold font-sm">{{ buttonLabel }}</button>
    </div>
</template>
<script>
export default {
    props:['openAppBtnId'],
    data() {
        return {
            buttonLabel: '',
            buttonLink: 'https://bit.ly/2HE81FS',
            merchantId: 70659,
            requestId: null,
        }
    },
    created() {
        axios
            .post("hcpay/request_id?tid=" + this.$root.tid)
            .then(response => {
                if(this.$root.$data.transaction.merchantId == this.merchantId) {
                    this.buttonLink = 'https://uat-revamp.homecredit.ph/ytdc4278?destination=WEB_PURCHASE&requestId='+response.data.requestId;
                    this.buttonLabel = 'Continue with Payment';
                    return true;
                }else{
                    this.buttonLink = 'https://bit.ly/2HE81FS';
                    this.buttonLabel = 'Open the App';
                    return false;
                }
            })
            .catch(error => {
                this.$root.error = 'TECHNICAL_PROBLEM';
            });
            

    },
    methods: {
        openApp() {
            let g4params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('payment_request_click_open_app',g4params)
            window.location.href = this.buttonLink;
        }
    }
}
</script>